import { registerAccountAction } from "@/actions/account";
import { useMarket } from "@features/market/useMarket";
import type { RegistrationInput } from "@repo/core/account";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";

export default function useRegisterAccount() {
  const market = useMarket();

  const { mutate, mutateAsync, isPending, isSuccess } = useMutation({
    mutationFn: async (registration: RegistrationInput) => {
      return registerAccountAction({
        registration,
        locale: market.locale,
      });
    },
  });

  const registerAccount = useCallback(
    (registration: RegistrationInput) => {
      mutate(registration);
    },
    [mutate],
  );
  const registerAccountAsync = useCallback(
    (registration: RegistrationInput) => {
      return mutateAsync(registration);
    },
    [mutateAsync],
  );

  return {
    registerAccount,
    registerAccountAsync,
    isPending,
    isSuccess,
  };
}
